import { BaseModal } from "@/components/general/base-modal/BaseModal";
import { useTranslation, Trans } from "react-i18next";
import { Typo } from "@pepperstone/pepper-ui-kit";
import { IFRAME_MODAL_MAX_WIDTH } from "../constants";
import style from "./IframeWithManualApproveModal.module.css";

type IframeWithManualApproveModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  iframeUrl: string;
};

export const IframeWithManualApproveModal = ({
  isOpen,
  onClose,
  onConfirm,
  iframeUrl,
}: IframeWithManualApproveModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      testId="iframe-manual-confirm-modal"
      maxWidth={IFRAME_MODAL_MAX_WIDTH}
      headerClassName={style.header}
      dialogClassName={style.dialog}
      cancelButtonContent={t("deposit.iframe_with_manual_approval_modal.back")}
      onCancel={onClose}
      submitButtonContent={t(
        "deposit.iframe_with_manual_approval_modal.i-paid"
      )}
      onSubmit={onConfirm}
    >
      <Typo elem="p" type="body" size="md" classes={style.description}>
        <Trans
          i18nKey="deposit.iframe_with_manual_approval_modal.description"
          components={{ bold: <strong /> }}
        />
      </Typo>
      <iframe
        src={iframeUrl}
        title="payment-iframe-manual"
        className={style.iframe}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation"
      />
    </BaseModal>
  );
};
